//Used for Polyfills.
//TODO: Only import what is needed instead of whole things.
import 'core-js'

import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { Route } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import ReduxThunk from 'redux-thunk';
import { StyleRoot } from 'radium';

import './index.css';

import GoogleAnalyticsTracking from './component/GoogleAnalyticsTracking'
import App from './App';
import reducers from './reducers';

const history = createHistory()
const store = createStore(reducers, applyMiddleware(routerMiddleware(history), ReduxThunk))

const element = (
    <StyleRoot>
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Route component={GoogleAnalyticsTracking(App)} />
			</ConnectedRouter>
		</Provider>
	</StyleRoot>
)

ReactDOM.render(element, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js